import { useEffect } from 'react'
import { ReactComponent as LirariLandingPageMobileLogo } from './../../assets/images/lirari-landing-page-mobile-logo.svg'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { myUserAtom } from '../../State/Musician/myUserAtom'
import { Skill } from '../../Api/Lirari/Types/skill'
import { Genre } from '../../Api/Lirari/Types/genre'
import { Offering } from '../../Api/Lirari/Types/offering'
import { PortfolioLink } from '../../Api/Lirari/Types/portfolioLinks'

const VerifyEmailPage = () => {
  const { user, isAuthenticated, logout } = useAuth0()
  const navigate = useNavigate()
  const [, setMyUser] = useAtom(myUserAtom)

  useEffect(() => {
    // If user is authenticated and email is verified, redirect to appropriate page
    if (isAuthenticated && user?.email_verified) {
      navigate('/redirect')
    }
  }, [isAuthenticated, user, navigate])

  const handleLogout = () => {
    // Clear user state before logout
    setMyUser({
      id: '',
      auth0Id: '',
      firstName: '',
      lastName: '',
      email: '',
      about: '',
      locationFormattedString: '',
      profileImageUrl: '',
      profileAudioUrl: '',
      socialLinks: { youtube: '', spotify: '', soundCloud: '' },
      userSkills: [] as Skill[],
      userGenres: [] as { genre: Genre }[],
      userOfferings: [] as { offering: Offering }[],
      portfolioLinks: [] as PortfolioLink[],
    })
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <div className="bg-white flex flex-col min-h-screen px-4">
      <div className="flex justify-center items-center py-4 sm:py-6 md:py-8">
        <LirariLandingPageMobileLogo className="h-36 sm:h-48 md:h-64" />
      </div>
      <div className="flex-1 flex justify-center items-center pb-8">
        <div className="w-full max-w-md flex flex-col items-center text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-6">
            Please Verify Your Email
          </h1>
          <p className="text-lg sm:text-xl text-black mb-2">{"We've sent a verification email to:"}</p>
          <p className="text-lg sm:text-xl font-bold text-black mb-4">{user?.email}</p>
          <p className="text-base sm:text-lg text-black mb-8">
            Please check your inbox and click the verification link.
          </p>

          <div className="w-full flex flex-col gap-4">
            <button
              onClick={handleLogout}
              className="bg-[#8830C7] text-white py-3 px-6 rounded-full hover:bg-[#8830C7]/90 transition-colors text-base sm:text-lg w-full"
            >
              Log out
            </button>

            <p className="text-sm sm:text-base text-gray-600 px-4">
              {"Didn't receive the email? Check your spam folder or try logging out and logging back in."}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyEmailPage
